module.exports = __webpack_public_path__ + "static/img/img-p2.7718f3d2.jpg";